
export default "/assets/ellipsis-horizontal-micro.b85ace56.svg"